export default __webpack_public_path__ + "9df0a8674259e2e12ee05d616dac0a08.png";